var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
let PartEditDialog = class PartEditDialog extends LitElement {
    constructor() {
        super();
        this.addTag = () => {
            const field = this.renderRoot.querySelector('#new-tag');
            const value = field.value.trim();
            if (value && !this.draftTags.some((tag) => tag.toLowerCase() === value.toLowerCase())) {
                this.draftTags = [...this.draftTags, value];
            }
            field.value = '';
        };
        this.submit = (event) => {
            event.preventDefault();
            const form = event.currentTarget;
            const data = new FormData(form);
            const quantity = Number(data.get('quantity'));
            if (!Number.isSafeInteger(quantity) || quantity < 0) {
                this.errorMessage = 'Quantity must be zero or a positive whole number.';
                return;
            }
            const detail = {
                id: this.currentPart.id,
                name: String(data.get('name') ?? ''),
                description: String(data.get('description') ?? ''),
                quantity,
                bucketId: String(data.get('bucket_id') ?? ''),
                tags: this.draftTags,
            };
            this.dispatchEvent(new CustomEvent('df-bucket-locator-part-edit', {
                detail, bubbles: true, composed: true,
            }));
        };
        this.currentPart = null;
        this.buckets = [];
        this.tags = [];
        this.draftTags = [];
        this.errorMessage = '';
        this.loadedPartId = '';
    }
    static { this.styles = css `
    md-dialog { --md-dialog-container-shape: 8px; }
    md-dialog [slot='content'] {
      display: grid;
      gap: 12px;
      min-width: min(440px, 76vw);
    }
    md-dialog [slot='headline'] {
      font-family: 'Manrope', 'Avenir Next', sans-serif;
      font-weight: 700;
    }
    md-dialog [slot='actions'] { display: flex; gap: 8px; }
    .edit-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: center;
      gap: 10px;
    }
    .tag-list { display: flex; flex-wrap: wrap; gap: 7px; }
    .error { color: #812f22; }
    @media (max-width: 560px) {
      md-dialog [slot='content'] { min-width: min(300px, 72vw); }
      .edit-row { grid-template-columns: 1fr; }
    }
  `; }
    updated() {
        if (this.currentPart && this.currentPart.id !== this.loadedPartId) {
            this.loadedPartId = this.currentPart.id;
            this.draftTags = [...this.currentPart.tags];
        }
    }
    render() {
        if (!this.currentPart)
            return nothing;
        return html `
      <md-dialog aria-label="Edit part details">
        <div slot="headline">Edit part</div>
        <form slot="content" id="part-edit-form" @submit=${this.submit}>
          <md-outlined-text-field label="Part name" name="name" required minlength="2" maxlength="120" .value=${this.currentPart.name}></md-outlined-text-field>
          <md-outlined-text-field label="Description" name="description" type="textarea" required minlength="3" maxlength="2000" .value=${this.currentPart.description}></md-outlined-text-field>
          <div class="edit-row">
            <md-outlined-text-field label="Quantity" name="quantity" type="number" min="0" step="1" required .value=${String(this.currentPart.quantity)}></md-outlined-text-field>
            <md-filled-select label="Bucket" name="bucket_id" .value=${this.currentPart.bucket_id}>
              ${this.buckets.map((bucket) => html `<md-select-option value=${bucket.id}><div slot="headline">${bucket.id} · ${bucket.location_name}</div></md-select-option>`)}
            </md-filled-select>
          </div>
          <div class="tag-list" aria-label="Part tags">
            ${this.draftTags.map((tag) => html `<md-outlined-button @click=${() => this.removeTag(tag)}>${tag} ×</md-outlined-button>`)}
          </div>
          <div class="edit-row">
            <md-outlined-text-field id="new-tag" label="Add tag" maxlength="40"></md-outlined-text-field>
            <md-outlined-button type="button" @click=${this.addTag}>Add</md-outlined-button>
          </div>
          ${this.errorMessage ? html `<p class="error" role="alert">${this.errorMessage}</p>` : nothing}
        </form>
        <div slot="actions">
          <md-text-button @click=${this.close}>Cancel</md-text-button>
          <md-filled-button form="part-edit-form" type="submit">Save changes</md-filled-button>
        </div>
      </md-dialog>
    `;
    }
    show() {
        this.draftTags = [...(this.currentPart?.tags ?? [])];
        this.errorMessage = '';
        void this.updateComplete.then(() => this.renderRoot.querySelector('md-dialog')?.show());
    }
    closeDialog() {
        this.renderRoot.querySelector('md-dialog')?.close();
    }
    removeTag(tag) {
        this.draftTags = this.draftTags.filter((value) => value !== tag);
    }
    close() {
        this.renderRoot.querySelector('md-dialog')?.close();
        this.dispatchEvent(new CustomEvent('df-bucket-locator-edit-close', { bubbles: true, composed: true }));
    }
};
__decorate([
    property({ attribute: false })
], PartEditDialog.prototype, "currentPart", void 0);
__decorate([
    property({ attribute: false })
], PartEditDialog.prototype, "buckets", void 0);
__decorate([
    property({ attribute: false })
], PartEditDialog.prototype, "tags", void 0);
__decorate([
    state()
], PartEditDialog.prototype, "draftTags", void 0);
__decorate([
    state()
], PartEditDialog.prototype, "errorMessage", void 0);
PartEditDialog = __decorate([
    customElement('part-edit-dialog')
], PartEditDialog);
export { PartEditDialog };
//# sourceMappingURL=part-edit-dialog.js.map